import type { ReactNode } from "react";
import { useNavigate } from "@tanstack/react-router";
import { Button } from "@wondermaps/ui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import { SuperadminUserMenu } from "./SuperadminUserMenu";

interface SuperadminHeaderProps {
  title: string;
  subtitle?: string | ReactNode;
  backTo?: string;
  actions?: ReactNode;
}

export function SuperadminHeader({
  title,
  subtitle,
  backTo = "/superadmin",
  actions,
}: SuperadminHeaderProps) {
  const navigate = useNavigate();

  return (
    <header className="border-b">
      <div className="container mx-auto flex items-center gap-4 px-4 py-3">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate({ to: backTo as "/" })}
        >
          <FontAwesomeIcon icon={faArrowLeft} className="h-4 w-4" />
        </Button>
        <div className="flex-1">
          <h1 className="text-lg font-semibold">{title}</h1>
          {subtitle &&
            (typeof subtitle === "string" ? (
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            ) : (
              subtitle
            ))}
        </div>
        {actions}
        <SuperadminUserMenu />
      </div>
    </header>
  );
}
